// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1HSKu","name":"ConsentHeader_name__HBqnJ","birthday":"ConsentHeader_birthday__2_e6Q","skeleton":"ConsentHeader_skeleton__1QQ7-"};